<template>
  <div>
    <!-- Modal de criação (inalterado) -->
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      id="create"
      title="NOVO CENTRO DE CUSTO/LUCRO"
    >
      <Create @success="paginate" />
    </b-modal>

    <div class="row">
      <div class="col-md-8 border">
        <!-- Cabeçalho da página -->
        <div class="row">
          <div
            class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pr-0 d-flex align-items-center"
          >
            <h1 class="title-pages">CENTROS DE CUSTO/LUCRO</h1>
          </div>
          <div
            class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pl-0 text-right"
          >
            <v-btn
              v-if="permission('write', 'financial_profit_cost_center')"
              @click="$bvModal.show('create')"
              class="btn-add m-1"
            >
              <i class="fas fa-plus mr-2 text-twenty" aria-hidden="true"></i>
              ADICIONAR
            </v-btn>
          </div>
        </div>

        <!-- Busca + cabeçalho da tabela -->
        <div v-show="data.length > 0">
          <div class="row">
            <div class="col-md-12">
              <div class="input-group">
                <!-- Rótulo invisível: o placeholder some ao digitar e não substitui label -->
                <label for="cost-center-search" class="sr-only">
                  Pesquisar centro de custo/lucro
                </label>
                <input
                  id="cost-center-search"
                  v-model="search"
                  type="search"
                  class="form-control"
                  placeholder="Pesquisar centro pai ou filho..."
                  autocomplete="off"
                />
                <div
                  class="input-group-pprend d-flex align-items-center justify-content-center"
                >
                  <v-btn disabled aria-hidden="true" tabindex="-1">
                    <i class="fas fa-search" />
                  </v-btn>
                </div>
              </div>
            </div>
            <div class="col-md-8"><span class="ml-2">Nome</span></div>
            <div class="col-md-2">Status</div>
            <div class="col-md-2">Ação</div>
          </div>
        </div>

        <b-overlay :show="loading" opacity="0.99">
          <!-- Estado 1: nenhum cadastro -->
          <div
            class="v-clean p-5 text-center"
            v-show="!loading && data.length === 0"
          >
            <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
          </div>

          <!-- Estado 2: há cadastros, mas a busca não encontrou nada -->
          <div
            class="v-clean p-5 text-center"
            v-show="data.length > 0 && rows.length === 0"
            role="status"
          >
            <h6 class="text-center worksansr">
              Nenhum centro encontrado para "{{ search }}"
            </h6>
          </div>

          <!-- Lista achatada: pai seguido de seus filhos -->
          <div role="list" aria-label="Centros de custo/lucro">
            <div
              v-for="row in rows"
              :key="row.key"
              role="listitem"
              :class="['cc-row', { 'cc-row--child': row.isChild }]"
            >
              <hr class="m-0" />
              <div class="row">
                <!-- Nome -->
                <div class="col-md-8 d-flex align-items-center">
                  <span
                    v-if="row.isChild"
                    class="cc-row__branch"
                    aria-hidden="true"
                    >└</span
                  >
                  <span :class="['ml-2', { 'font-weight-bold': !row.isChild }]">
                    {{ row.item.description }}
                  </span>
                  <!-- Contexto para leitor de tela -->
                  <span v-if="row.isChild" class="sr-only">
                    , filho de {{ row.parent.description }}
                  </span>
                  <small
                    v-if="!row.isChild && row.childrenCount > 0"
                    class="cc-row__count ml-2"
                  >
                    ({{ row.childrenCount }}
                    {{ row.childrenCount === 1 ? "filho" : "filhos" }})
                  </small>
                </div>

                <!-- Status: cor + texto (nunca só cor) -->
                <div class="col-md-2 d-flex align-items-center">
                  <span>
                    <i
                      aria-hidden="true"
                      :class="[
                        'fas fa-circle',
                        row.item.status == 1 ? 'color-green' : 'color-warning',
                      ]"
                    ></i>
                    {{ row.item.status == 1 ? "ATIVO" : "INATIVO" }}
                  </span>
                </div>

                <!-- Ação -->
                <div class="col-md-2 d-flex align-items-center">
                  <b-modal
                    size="md"
                    no-close-on-backdrop
                    hide-footer
                    :id="`edit-${row.item.id}`"
                    :title="`EDITAR CENTRO DE CUSTO/LUCRO: ${row.item.description}`"
                  >
                    <!-- Passa o objeto ORIGINAL; o Edit não precisa mudar -->
                    <Edit @success="paginate" :data="row.item" />
                  </b-modal>
                  <v-btn
                    v-if="permission('edit', 'financial_profit_cost_center')"
                    x-small
                    class="v-primary"
                    :aria-label="`Editar ${row.item.description}`"
                    @click="edit(row.item)"
                  >
                    EDITAR
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </b-overlay>
      </div>

      <!-- Texto de ajuda (inalterado) -->
      <div class="col-md-4">
        <h6>O que são centros de custo/lucro?</h6>
        <p class="worksansr">
          Centro de custo / lucro
          <b
            >é uma separação interna a uma empresa ou organização para rastrear
            despesas e receitas</b
          >. Essas unidades são usadas para associar custos e pagamentos
          arrecadados a projetos, departamentos ou filiais de uma empresa, por
          exemplo. Com suas despesas agrupadas por centro de custo é possível
          obter dados como: O centro de custo <b>"FILIAL X"</b> teve um custo
          total de <b>X</b> e um <b>lucro total</b> de <b>Y</b>. Ou ainda, O
          centro de custo <b>"OBRA Y"</b> teve um custo <b>X</b> com
          <b>energia elétrica</b>, um custo <b>Y</b> com <b>mão de obra</b>,
          etc.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Create from "./CostProfitCenter/Create";
import Edit from "./CostProfitCenter/Edit";
import api from "../../../services/api";
import permission from "../../../lib/permission";
import { getRestHomeSelectedFinancialAccount } from "../../../lib/functions";

/**
 * Normaliza texto para busca: minúsculo e sem acentos.
 * "Manutenção" -> "manutencao"
 */
const normalize = (value) =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

export default {
  name: "CostProfitCenter",

  components: { Create, Edit },

  data() {
    return {
      data: [], // árvore vinda da API (pais com filhos em `data`)
      search: "", // termo de busca (substitui o antigo `filtered`)
      loading: false,
    };
  },

  computed: {
    /**
     * Transforma a árvore em lista linear para renderização.
     * Regras de busca:
     *  - pai casa com o termo  -> mostra o pai e TODOS os filhos;
     *  - só filho casa         -> mostra o pai (contexto) e só os filhos que casam;
     *  - nada casa             -> omite o grupo.
     */
    rows() {
      const term = normalize(this.search);
      const rows = [];

      this.data.forEach((parent) => {
        const children = Array.isArray(parent.data) ? parent.data : [];
        const parentMatches =
          !term || normalize(parent.description).includes(term);

        const visibleChildren = parentMatches
          ? children
          : children.filter((child) =>
              normalize(child.description).includes(term)
            );

        if (!parentMatches && visibleChildren.length === 0) return;

        rows.push({
          key: `parent-${parent.id}`,
          isChild: false,
          item: parent,
          childrenCount: children.length,
        });

        visibleChildren.forEach((child) => {
          rows.push({
            key: `child-${child.id}`,
            isChild: true,
            item: child,
            parent,
          });
        });
      });

      return rows;
    },
  },

  created() {
    this.paginate();
  },

  methods: {
    getRestHomeSelectedFinancialAccount,
    permission,

    async paginate() {
      this.loading = true;
      try {
        const params = {
          rest_home_id_selected_financial_account:
            this.getRestHomeSelectedFinancialAccount(),
        };

        const response = await api.get(
          "/rest-home/financial/configuration/profit-cost-center",
          { params }
        );

        // O termo de busca é mantido; `rows` recalcula sozinho.
        this.data = response.data.data || [];
      } catch (error) {
        console.log(error);
      } finally {
        // Garante que o overlay nunca trave a tela em caso de erro.
        this.loading = false;
      }
    },

    edit(item) {
      this.$bvModal.show(`edit-${item.id}`);
    },
  },
};
</script>

<style scoped>
/* Estilos locais: os arquivos CSS padrão do projeto não são alterados. */

/* Fundo sutil agrupa visualmente os filhos sob o pai (Proximidade) */
.cc-row--child {
  background-color: #fafafa;
}

/* Recuo + conector indicam o segundo nível da hierarquia */
.cc-row__branch {
  margin-left: 1.5rem;
  color: #5a6268; /* contraste ~6:1 sobre #fafafa (AA) */
  font-weight: bold;
}

.cc-row__count {
  color: #5a6268;
}
</style>